/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateAwsIamCredentialRequestBody,
  UpdateAwsIamCredentialRequestBody$Outbound,
  UpdateAwsIamCredentialRequestBody$outboundSchema,
} from "../components/updateawsiamcredentialrequestbody.js";

export type UpdateAwsIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateAwsIamCredentialRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateAwsIamCredentialRequestBody: UpdateAwsIamCredentialRequestBody;
};

/** @internal */
export type UpdateAwsIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateAwsIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  UpdateAwsIamCredentialSecurity$Outbound,
  UpdateAwsIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateAwsIamCredentialSecurityToJSON(
  updateAwsIamCredentialSecurity: UpdateAwsIamCredentialSecurity,
): string {
  return JSON.stringify(
    UpdateAwsIamCredentialSecurity$outboundSchema.parse(
      updateAwsIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type UpdateAwsIamCredentialRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateAwsIamCredentialRequestBody: UpdateAwsIamCredentialRequestBody$Outbound;
};

/** @internal */
export const UpdateAwsIamCredentialRequest$outboundSchema: z.ZodMiniType<
  UpdateAwsIamCredentialRequest$Outbound,
  UpdateAwsIamCredentialRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateAwsIamCredentialRequestBody:
      UpdateAwsIamCredentialRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateAwsIamCredentialRequestBody: "UpdateAwsIamCredentialRequestBody",
    });
  }),
);

export function updateAwsIamCredentialRequestToJSON(
  updateAwsIamCredentialRequest: UpdateAwsIamCredentialRequest,
): string {
  return JSON.stringify(
    UpdateAwsIamCredentialRequest$outboundSchema.parse(
      updateAwsIamCredentialRequest,
    ),
  );
}
